/**
 * Job Details mock options + default values for Review Request.
 * Field keys/labels mirror People → Add New Employee → Job Details.
 */

export const JOB_DETAILS_OPTIONS = {
  confirmationStatus: ["Probation", "Confirmed", "Extended"],
  employeeType: ["Permanent", "Temporary", "Contract", "Intern"],
  employeeSubType: ["On-roll", "Off-roll", "Consultant"],
  employmentType: ["Full-time", "Part-time", "Fixed-term"],
  jobBand: ["B1", "B2", "B3", "B4", "B5"],
  jobGrade: ["G1", "G2", "G3", "G4", "G5"],
  designationNameAndCode: [
    "Store Associate (STA-014)",
    "Cashier (CSH-021)",
    "Store Manager (STM-008)",
    "Team Leader (TL-012)",
  ],
  jobLevelAndCode: ["L1 (JL-01)", "L2 (JL-02)", "L3 (JL-03)", "L4 (JL-04)"],
  businessUnit: [
    "Retail — South",
    "Retail — North",
    "Retail — West",
    "Retail — East",
    "Corporate",
  ],
  businessUnitHeadName: [
    "Anand Kumar",
    "Priya Sharma",
    "Vikram Singh",
    "Meera Nair",
  ],
  departmentCode: ["DEPT-014", "DEPT-021", "DEPT-008", "DEPT-033"],
  departmentHierarchy: [
    "Retail > Store Operations > Koramangala",
    "Retail > Store Operations > Indiranagar",
    "Retail > Merchandising > HO",
    "Corporate > HR > HO",
  ],
  groupCompanyCode: [
    "More Retail Pvt Ltd (MRPL)",
    "Aditya Birla Retail Ltd (ABRL)",
  ],
  baseOfficeLocation: [
    "More Hypermarket, Koramangala",
    "More Megastore, Indiranagar",
    "More Express, Whitefield",
    "Head Office, Mumbai",
  ],
  locTypeList: ["Store", "Warehouse", "Office", "Hybrid"],
  officeCountry: ["India"],
  officeState: [
    "Karnataka",
    "Maharashtra",
    "Tamil Nadu",
    "Telangana",
    "Delhi",
  ],
  officeCity: [
    "Bengaluru",
    "Mumbai",
    "Chennai",
    "Hyderabad",
    "New Delhi",
    "Pune",
  ],
  costCenter: ["CC-2201-KOR", "CC-2202-IND", "CC-1100-HO", "CC-3301-WH"],
  workAreaCode: ["WA-014", "WA-021", "WA-008", "WA-001"],
  timeZone: ["IST (UTC+5:30)", "UTC"],
  attendanceShift: [
    "Morning (8 AM – 4 PM)",
    "Afternoon (12 PM – 8 PM)",
    "Evening (4 PM – 12 AM)",
    "General (9 AM – 6 PM)",
  ],
  attendancePolicy: [
    "Store Staff — Standard",
    "HO Staff — Standard",
    "Flexible",
  ],
  attendanceWeeklyOff: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ],
  vendorName: ["—", "Vendor A", "Vendor B", "Vendor C"],
  billAmazon: [
    { key: "0%", value: 0 },
    { key: "10%", value: 10 },
    { key: "20%", value: 20 },
    { key: "30%", value: 30 },
    { key: "40%", value: 40 },
    { key: "50%", value: 50 },
    { key: "60%", value: 60 },
    { key: "70%", value: 70 },
    { key: "80%", value: 80 },
    { key: "90%", value: 90 },
    { key: "100%", value: 100 },
  ],
  channel: [
    { key: "Amazon", value: "Amazon" },
    { key: "Amazon Express", value: "Amazon Express" },
    { key: "More", value: "More" },
    { key: "Omni", value: "Omni" },
    { key: "More Cafe", value: "More Cafe" },
  ],
};

/** Mock employees for Direct Manager / HRBP typeahead */
export const JOB_DETAILS_EMPLOYEE_SEARCH = [
  {
    employee_id: "EMP10231",
    full_name: "Kavitha Reddy",
    company_email_id: "kavitha.reddy@more.in",
  },
  {
    employee_id: "EMP10877",
    full_name: "Rohan Das",
    company_email_id: "rohan.das@more.in",
  },
  {
    employee_id: "EMP11502",
    full_name: "Anjali Mehta",
    company_email_id: "anjali.mehta@more.in",
  },
  {
    employee_id: "EMP12044",
    full_name: "Suresh Pillai",
    company_email_id: "suresh.pillai@more.in",
  },
];

/** Default mock job details — replace with API payload later */
export const baseJobDetails = {
  employee_id: "EMP24601",
  date_of_joining: "2026-08-04",
  date_of_confirmation: "2027-02-04",
  confirmation_status: "Probation",
  employee_type: "Permanent",
  employee_sub_type: "On-roll",
  employment_type: "Full-time",
  band: "B1",
  grade: "G3",
  division: "Retail Operations",
  designation: "Store Associate (STA-014)",
  position_id: "Store Associate (POS-2201)",
  job_level: "L2 (JL-02)",
  business_unit: "Retail — South",
  business_unit_head: "Anand Kumar",
  department_code: "DEPT-014",
  departments_hierarchy: "Retail > Store Operations > Koramangala",
  group_company_code: "More Retail Pvt Ltd (MRPL)",
  base_office_location: "More Hypermarket, Koramangala",
  location_type: "Store",
  office_country: "India",
  office_state: "Karnataka",
  office_region: "South",
  office_city: "Bengaluru",
  city_type: "Metro",
  cost_center: "CC-2201-KOR",
  centre_type: "Hypermarket",
  work_area_code_x: "WA-014",
  direct_manager_employee_id: "EMP10231",
  direct_manager_name: "Kavitha Reddy",
  direct_manager_email: "kavitha.reddy@more.in",
  hrbp_employee_id: "EMP10877",
  hrbp_name: "Rohan Das",
  hrbp_email_id: "rohan.das@more.in",
  time_zone: "IST (UTC+5:30)",
  attendance_shift: "Morning (8 AM – 4 PM)",
  attendance_policy: "Store Staff — Standard",
  attendance_weeklyoff: "Tuesday",
  contribution_level: "Individual contributor",
  functional_area: "Store Operations",
  functional_area_cost_center: "FCC-2201 / Store Ops",
  vendor_name: "—",
  vendor_emp_id: "—",
  bill_amazon: 100,
  workforce_engagement: "Direct hire",
  channel: "More",
  misc: {
    source_of_job_application: "Employee referral",
    previous_worked_for_more: false,
    previousEmpCode: "",
    previousEmailID: "",
    family_in_more: false,
    more_user_details: "",
  },
};
